// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".site-search-result{display:flex;flex-direction:column}.site-search-result_node a{max-width:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
